
export enum BlogType {
  Blog = 'blog',
  IoSonoVege = 'iosonovege',
  PressReleases = 'press-releases',
}